// extracted by mini-css-extract-plugin
module.exports = {"base":"Badge_base__uwLQe","dashed":"Badge_dashed__3tYr2","id":"Badge_id__1K05w","header":"Badge_header__2R3Yp","state":"Badge_state__1mdkh","neutral":"Badge_neutral__1SHTf"};